import { render, staticRenderFns } from "./UserExcuseTypeView.vue?vue&type=template&id=4d4deec1"
import script from "./UserExcuseTypeView.vue?vue&type=script&lang=js"
export * from "./UserExcuseTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports